import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Typography, Space, Spin, theme } from "antd";
import {
  MessageOutlined,
  ContactsOutlined,
  PhoneOutlined,
  RobotOutlined,
  BookOutlined,
  BankOutlined,
  BuildOutlined,
  ArrowRightOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import API_BASE_URL from "../config/api";

const { Title, Text } = Typography;

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalAgents: 0,
    totalConversations: 0,
    totalContacts: 0,
    activeCalls: 0,
    totalCalls: 0,
    pickupCalls: 0,
    interestedCalls: 0,
    notInterestedCalls: 0,
  });
  console.log(stats, "stats...............");
  const [loading, setLoading] = useState(true);
  const {
    token: { colorPrimary, colorSuccess, colorWarning, colorError, colorInfo },
  } = theme.useToken();

  const updatedColors = {
    colorPrimary: "#1890ff",
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorError: "#ff4d4f",
    colorInfo: "#1890ff",
  };

  const modules = [
    {
      name: "Agents",
      path: "/agents",
      description: "Manage your AI calling agents and their configurations",
      icon: (
        <RobotOutlined
          style={{ fontSize: 32, color: updatedColors.colorPrimary }}
        />
      ),
      color: colorPrimary,
    },
    {
      name: "Conversations",
      path: "/conversations",
      description: "View conversation history and analytics",
      icon: <MessageOutlined style={{ fontSize: 32, color: colorSuccess }} />,
      color: colorSuccess,
    },
    // {
    //   name: "Knowledge Base",
    //   path: "/knowledge-base",
    //   description: "Manage knowledge base entries and training data",
    //   icon: <BookOutlined style={{ fontSize: 32, color: colorWarning }} />,
    //   color: colorWarning,
    // },
    {
      name: "Contacts",
      path: "/contacts",
      description: "Manage contact information and customer data",
      icon: <ContactsOutlined style={{ fontSize: 32, color: colorError }} />,
      color: colorError,
    },
    {
      name: "Batch Calls",
      path: "/batch-calls",
      description: "Schedule and manage batch call campaigns",
      icon: <BuildOutlined style={{ fontSize: 32, color: colorInfo }} />,
      color: colorInfo,
    },
    {
      name: "Companies",
      path: "/companies",
      description: "Manage company settings and branch information",
      icon: <BankOutlined style={{ fontSize: 32, color: colorWarning }} />,
      color: colorWarning,
    },
    // {
    //   name: "Phone Numbers",
    //   path: "/phone-numbers",
    //   description: "Configure phone numbers and routing",
    //   icon: <PhoneOutlined style={{ fontSize: 32, color: colorError }} />,
    //   color: colorError,
    // },
    {
      name: "Offers",
      path: "/offers",
      description: "Create and manage promotional offers",
      icon: <DollarOutlined style={{ fontSize: 32, color: colorSuccess }} />,
      color: colorSuccess,
    },
  ];

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No authentication token found");
          setLoading(false);
          return;
        }

        console.log("Fetching dashboard data from APIs...");

        console.log("Fetching batch-calls pickup_count from API...");
        const batchResponse = await fetch(
          `${API_BASE_URL}/batch-calls/pickup_count`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Batch-calls API Response Status:", batchResponse.status);

        if (!batchResponse.ok) {
          throw new Error(`HTTP error! status: ${batchResponse.status}`);
        }

        const batchData = await batchResponse.json();
        console.log("Batch-calls pickup_count API Response:", batchData);

        console.log("Fetching agents from API...");
        const agentsResponse = await fetch(`${API_BASE_URL}/agents`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        console.log("Agents API Response Status:", agentsResponse.status);

        if (!agentsResponse.ok) {
          throw new Error(`HTTP error! status: ${agentsResponse.status}`);
        }

        const agentsData = await agentsResponse.json();
        console.log("Agents API Response:", agentsData);

        const conversationsResponse = await fetch(
          `${API_BASE_URL}/conversations`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const conversationsData = await conversationsResponse.json();

        console.log("Fetching contacts count from API...");
        const contactsResponse = await fetch(`${API_BASE_URL}/contacts`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        console.log("Contacts API Response Status:", contactsResponse.status);

        if (!contactsResponse.ok) {
          throw new Error(`HTTP error! status: ${contactsResponse.status}`);
        }

        const contactsData = await contactsResponse.json();
        console.log("Contacts API Response:", contactsData);

        console.log("Fetching dispositions counts from API...");
        const dispositionsResponse = await fetch(
          `${API_BASE_URL}/dispositions/counts`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log(
          "Dispositions API Response Status:",
          dispositionsResponse.status
        );

        if (!dispositionsResponse.ok) {
          throw new Error(`HTTP error! status: ${dispositionsResponse.status}`);
        }

        const dispositionsData = await dispositionsResponse.json();
        console.log("Dispositions API Response:", dispositionsData);

        let batchStats = {
          pickupCalls: 0,
          totalCalls: 0,
        };

        const result = batchData.data.result[0];
        batchStats = {
          pickupCalls: result.completed_count || 0,
          totalCalls: result.totalCount || 0,
          notInterestedCount: result.not_interested_count || 0,
          intrestedCount: result.interested_count || 0,
        };

        setStats({
          totalAgents: agentsData?.count,
          totalConversations: conversationsData?.total,
          totalContacts: contactsData?.total_contacts || 0,
          interestedCalls: dispositionsData.data?.Interested || 0,
          notInterestedCalls: dispositionsData.data?.["Not Interested"] || 0,
          ...batchStats,
        });
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const statsCards = [
    {
      title: "Total Agents",
      value: stats.totalAgents,
      icon: <RobotOutlined />,
      color: colorPrimary,
    },
    {
      title: "Conversations",
      value: stats.totalConversations,
      icon: <MessageOutlined />,
      color: colorSuccess,
    },
    {
      title: "Contacts",
      value: stats.totalContacts,
      icon: <ContactsOutlined />,
      color: colorWarning,
    },
  ];

  const performanceStats = [
    {
      title: "Total Calls",
      value: stats.totalCalls,
      icon: <ContactsOutlined />,
      progress: 100,
      color: colorPrimary,
    },
    {
      title: "Pickup Call",
      icon: <ContactsOutlined />,
      value: `${stats.pickupCalls} (${(
        (stats.pickupCalls / stats.totalCalls) *
        100
      ).toFixed(1)}%)`,
      progress: (stats.pickupCalls / stats.totalCalls) * 100,
      color: colorSuccess,
    },
    {
      title: "Interested Call",
      icon: <ContactsOutlined />,
      value: `${stats.intrestedCount} (${(
        (stats.intrestedCount / stats.totalCalls) *
        100
      ).toFixed(1)}%)`,
      progress:
        stats.totalCalls > 0
          ? (stats.interestedCalls / stats.totalCalls) * 100
          : 0,
      color: colorWarning,
    },
    {
      title: "Not Interested Call",
      icon: <ContactsOutlined />,
      value: `${stats.notInterestedCount} (${(
        (stats.notInterestedCount / stats.totalCalls) *
        100
      ).toFixed(1)}%)`,
      progress:
        stats.totalCalls > 0
          ? (stats.notInterestedCalls / stats.totalCalls) * 100
          : 0,
      color: colorError,
    },
  ];

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Header Section */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          AI Calling Agent Platform
        </Title>
        <Text type="secondary" style={{ fontSize: 16 }}>
          Welcome to your intelligent calling system. Manage agents,
          conversations, and campaigns all in one place.
        </Text>
      </div>

      {/* Stats Overview with Bootstrap Cards */}
      <div className="row g-3 mb-4">
        {statsCards.map((stat, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-4">
            <div
              className="card h-100 shadow-sm border-0"
              style={{
                borderTop: `4px solid ${stat.color}`,
                transition:
                  "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
              }}
            >
              <div className="card-body d-flex align-items-center">
                <div
                  className="me-3"
                  style={{ fontSize: "2rem", color: stat.color }}
                >
                  {stat.icon}
                </div>
                <div className="flex-grow-1">
                  <h6
                    className="card-title text-muted mb-1"
                    style={{ fontSize: "14px", fontWeight: 500 }}
                  >
                    {stat.title}
                  </h6>
                  <h3
                    className="mb-0"
                    style={{ color: stat.color, fontWeight: "bold" }}
                  >
                    {stat.value}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Performance Metrics with Bootstrap Cards */}
      <div className="row g-3 mb-4">
        {performanceStats.map((stat, index) => (
          <div key={index} className="col-lg-4 col-md-6">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-3">
                    <div
                      className="me-3"
                      style={{ fontSize: "2rem", color: stat.color }}
                    >
                      {stat.icon}
                    </div>
                  </div>
                  <div className="col-9 d-flex align-items-center justify-content-end text-end">
                    <div>
                      <h4
                        className="card-title"
                        style={{ color: stat.color, marginBottom: "0.25rem" }}
                      >
                        {stat.value}
                      </h4>
                      <p
                        className="card-subtitle mb-0"
                        style={{ fontSize: "14px", color: "#6c757d" }}
                      >
                        {stat.title}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="progress mt-3"
                  style={{ backgroundColor: "#f8f9fa", height: "6px" }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${stat.progress}%`,
                      height: "6px",
                      backgroundColor: stat.color,
                    }}
                    aria-valuenow={stat.progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Access Section */}
      <Title level={3} style={{ marginBottom: 16 }}>
        Quick Access
      </Title>

      {/* Modules Grid with Bootstrap Cards */}
      <div className="row g-3 mb-4">
        {modules.map((module, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
            <Link to={module.path} style={{ textDecoration: "none" }}>
              <div
                className="card h-100 shadow-sm border-0"
                style={{
                  borderTop: `4px solid ${module.color}`,
                  position: "relative",
                  transition:
                    "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                  cursor: "pointer",
                }}
              >
                <div className="card-body d-flex flex-column">
                  <div className="text-center mb-3">{module.icon}</div>
                  <div className="flex-grow-1">
                    <h5 className="card-title mb-2" style={{ color: "#333" }}>
                      {module.name}
                    </h5>
                    <p
                      className="card-text text-muted"
                      style={{ fontSize: "14px" }}
                    >
                      {module.description}
                    </p>
                  </div>

                  {/* Arrow in bottom-right corner */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: 12,
                      right: 12,
                    }}
                  >
                    <ArrowRightOutlined
                      style={{ color: module.color, fontSize: 18 }}
                    />
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <style jsx>{`
        .card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
        }

        .card {
          transition: all 0.2s ease-in-out;
        }

        .card-body {
          padding: 1.5rem;
        }

        .progress {
          border-radius: 3px;
        }

        .progress-bar {
          border-radius: 3px;
        }
      `}</style>
    </div>
  );
};

export default Dashboard;
